import { HttpHeaders } from '@angular/common/http';
import { Component, Input, ViewChild } from '@angular/core';
import {
  FileInfo,
  FileRestrictions,
  SelectEvent,
  UploadComponent,
  UploadEvent,
} from '@progress/kendo-angular-upload';
import { IDocumentType } from 'src/app/core/interfaces/common/document/document-type.interface';

type fileType = {
  name: string;
  documentTypeId: number;
  contentType: string | undefined;
  imgPath: string;
};
@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent {
  @ViewChild(UploadComponent)
  private uploadComponent: UploadComponent;
  @Input() uploadSaveUrl: string; // should represent an actual API endpoint
  @Input() uploadRemoveUrl: string; // should represent an actual API endpoint
  @Input() documentType: IDocumentType;
  @Input() multipleFile = false;
  @Input() additionalUploadParams: string;
  public value: string[] = [];
  @Input() onSubmit: () => void;
  public onChange: any = () => {};
  public onTouch: any = () => {};
  errorMessage = '';

  fileList: {
    documentTypeId: number;
    contentType: string | undefined;
    name: string;
    imgPath: string;
  }[] = [];

  fileRestrictions: FileRestrictions = {
    allowedExtensions: ['.pdf'],
    maxFileSize: 26214400, // 25mb
  };

  public onUpload(event: UploadEvent): void {
    const { files } = event;
    // Process the uploaded files as needed
    const fileNames = files.map((file) => file.name);
    this.value = fileNames;
    this.onChange(files);
    this.onTouch();
  }

  myFiles: Array<FileInfo> = [];

  selectEventHandler(event: SelectEvent): void {
    event.files.forEach((file) => {
      if (this.checkForDuplicates(file, this.myFiles)) {
        // this.kns.show('warning', 'You may not upload duplicate documents.');
      } else {
        this.myFiles.push(file);
      }
    });
    const uploadEvent = new UploadEvent(this.myFiles, new HttpHeaders());
    this.uploadEventHandler(uploadEvent);
  }

  async deleteDocument(file: fileType, event: Event) {
    event.stopPropagation(); // stops click event from propagating to dropzone
    this.fileList = this.fileList.filter(
      (tempFile) =>
        !(
          tempFile.contentType === file.contentType &&
          tempFile.documentTypeId === file.documentTypeId &&
          tempFile.name === file.name
        )
    );
    this.myFiles = this.myFiles.filter(
      (tempFile) =>
        !(
          tempFile.rawFile?.type === file.contentType &&
          tempFile.name === file.name
        )
    );
  }

  uploadEventHandler(event: UploadEvent): void {
    this.fileList = [];
    const len = event.files.length;
    if (this.documentType === undefined) {
      this.errorMessage = 'Select Document Type';
    } else {
      this.errorMessage = '';
      for (let i = 0; i < len; i += 1) {
        const kendoFile = event.files[i];
        this.fileList.push({
          name: kendoFile.name,
          documentTypeId: this.documentType.documentTypeId,
          contentType: kendoFile.rawFile?.type,
          imgPath: '../../../assets/images/thumb_pdf.png',
        });
      }

      const newFileName = event.files[len - 1].name;
      const newContentType = event.files[len - 1].rawFile?.type;
      const encodedDocumentTypeId = encodeURIComponent(
        this.documentType.documentTypeId.toString().trim()
      );
      const encodedFileName = encodeURIComponent(newFileName.trim());
      const encodedContentType = encodeURIComponent(
        newContentType?.trim() ?? ''
      );
      this.uploadComponent.saveUrl += `?documentTypeId=${encodedDocumentTypeId}&fileName=${encodedFileName}&contentType=${encodedContentType}${this.additionalUploadParams}`;
      this.uploadComponent.autoUpload = true;
      this.uploadComponent.upload.emit(event);
    }
  }

  uploadCleanUp() {
    this.uploadComponent.saveUrl = this.uploadSaveUrl;
    this.uploadComponent.autoUpload = false;
    this.fileList = [];
    this.onSubmit();
  }

  private checkForDuplicates(file: FileInfo, fileList: FileInfo[]): boolean {
    return fileList.some(
      (tempFile: FileInfo) =>
        tempFile.name === file.name &&
        tempFile.extension === file.extension &&
        tempFile.size === file.size
    );
  }
}
